import { Select } from '@base-ui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

import type { FilterOption } from './types'

type FilterSelectProps = {
  label: string
  value: string | number
  onChange: (value: string) => void
  options: FilterOption[]
  className?: string
}

const FilterSelect = ({
  label,
  value,
  onChange,
  options,
  className = 'flex-1',
}: FilterSelectProps) => {
  return (
    <div className={className}>
      {/* items lets Select.Value show the label before the popup has mounted. */}
      <Select.Root
        items={options}
        value={value}
        onValueChange={nextValue => onChange(String(nextValue ?? ''))}
      >
        <div className="form-control">
          <Select.Label className="label">
            <span className="label-text">{label}</span>
          </Select.Label>
          <div className="relative">
            <Select.Trigger className="select focus-within:bg-base-300 select-bordered inline-flex w-full items-center justify-between gap-2 text-left">
              <Select.Value />
              <Select.Icon className="shrink-0 text-base-content/70">
                <ChevronDownIcon className="h-4 w-4" />
              </Select.Icon>
            </Select.Trigger>
            <Select.Portal>
              {/* Above Slider's z-40 panel — both portal to body, so they share a stacking context. */}
              <Select.Positioner sideOffset={4} className="z-50">
                <Select.Popup className="w-(--anchor-width) max-h-72 overflow-y-auto rounded-box border border-base-300 bg-base-100 shadow-xl">
                  <Select.List className="w-full p-1">
                    {options.map(option => (
                      <Select.Item
                        key={option.value}
                        value={option.value}
                        className="flex cursor-default items-center justify-between rounded-md px-3 py-2 text-left data-highlighted:bg-base-200 data-selected:bg-base-200/70"
                        label={option.label}
                      >
                        <span>{option.label}</span>
                      </Select.Item>
                    ))}
                  </Select.List>
                </Select.Popup>
              </Select.Positioner>
            </Select.Portal>
          </div>
        </div>
      </Select.Root>
    </div>
  )
}

export type { FilterSelectProps }
export { FilterSelect }
